import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, userPrefPageSize } from '@/decorators';

var ShopDefaultThemeRecordPage = function (_super) {
  __extends(ShopDefaultThemeRecordPage, _super);

  function ShopDefaultThemeRecordPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.searchData = _this.initSearchData();
    _this.loadingStatus = false;
    _this.columns = [];
    _this.data = [];
    _this.total = 0;
    _this.bodyList = [];
    _this.countryList = [];
    _this.effectTimeRange = [];
    _this.effectStatusList = [{
      value: _this.$enum.common.BoolIntEnum.YES,
      text: _this.t('生效')
    }, {
      value: _this.$enum.common.BoolIntEnum.NO,
      text: _this.t('失效')
    }];
    return _this;
  }

  ShopDefaultThemeRecordPage.prototype.initSearchData = function () {
    return {
      shop_code: '',
      shop_name: '',
      account_code_list: [],
      country_code_list: [],
      effect_status: undefined,
      effect_start_time: '',
      effect_end_time: '',
      page_index: 1,
      page_size: 20
    };
  };

  ShopDefaultThemeRecordPage.prototype.onEffectTimeRangeChange = function (dateRange) {
    if (dateRange && dateRange.length === 2) {
      this.searchData.effect_start_time = this.$util.formatDateTime(dateRange[0], 'YYYY/MM/DD HH:mm:ss');
      this.searchData.effect_end_time = this.$util.formatDateTime(dateRange[1], 'YYYY/MM/DD HH:mm:ss');
    } else {
      this.searchData.effect_start_time = '';
      this.searchData.effect_end_time = '';
    }
  };

  ShopDefaultThemeRecordPage.prototype.handleSearch = function () {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.searchData.page_index = 1;
            return [4, this.queryList()];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  ShopDefaultThemeRecordPage.prototype.handleClear = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _this = this;

      return __generator(this, function (_a) {
        this.searchData = this.initSearchData();
        this.effectTimeRange = [];
        this.$nextTick(function () {
          return _this.queryList();
        });
        return [2];
      });
    });
  };

  ShopDefaultThemeRecordPage.prototype.handlePageChange = function (page, pageSize) {
    this.searchData.page_index = page;
    this.searchData.page_size = pageSize;
    this.queryList();
  };

  ShopDefaultThemeRecordPage.prototype.queryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, resData, _b, _c, list, _d, total;

      return __generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            postData = {
              shop_code: this.searchData.shop_code,
              shop_name: this.searchData.shop_name,
              account_code_list: this.searchData.account_code_list,
              country_code_list: this.searchData.country_code_list,
              effect_status: this.searchData.effect_status,
              effect_start_time: this.searchData.effect_start_time,
              effect_end_time: this.searchData.effect_end_time,
              page_index: this.searchData.page_index,
              page_size: this.searchData.page_size
            };
            return [4, this.$api.shopManage.queryRecordList(postData)];

          case 1:
            _a = _e.sent().data, resData = _a === void 0 ? {} : _a;
            _b = resData, _c = _b.list, list = _c === void 0 ? [] : _c, _d = _b.total, total = _d === void 0 ? 0 : _d;
            this.data = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  ShopDefaultThemeRecordPage.prototype.queryBodyList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.shopManage.getBodyList({})];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? {
              list: []
            } : _a;
            this.bodyList = data.list || [];
            return [2];
        }
      });
    });
  };

  ShopDefaultThemeRecordPage.prototype.queryCountryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.shopManage.getBusinessCountryList()];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.countryList = Array.isArray(data) ? data : [];
            return [2];
        }
      });
    });
  };

  ShopDefaultThemeRecordPage.prototype.created = function () {
    this.columns = [{
      title: this.t('序号'),
      dataIndex: 'index',
      width: 60,
      align: 'center',
      scopedSlots: {
        customRender: 'index'
      }
    }, {
      title: this.t('店铺编码'),
      dataIndex: 'shop_code',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('店铺名称'),
      dataIndex: 'shop_name',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('客户代码'),
      dataIndex: 'customer_code',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('账户编号'),
      dataIndex: 'account_code',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('主体名称'),
      dataIndex: 'sign_body_name',
      filterEmpty: true
    }, {
      title: this.t('业务发生国'),
      dataIndex: 'country',
      scopedSlots: {
        customRender: 'country'
      }
    }, {
      title: this.t('是否默认主体'),
      dataIndex: 'is_default',
      scopedSlots: {
        customRender: 'is_default'
      }
    }, {
      title: this.t('默认主体生效开始时间'),
      dataIndex: 'effect_start_time',
      filterEmpty: true
    }, {
      title: this.t('默认主体生效结束时间'),
      dataIndex: 'effect_end_time',
      filterEmpty: true
    }, {
      title: this.t('生效状态'),
      dataIndex: 'effect_status',
      scopedSlots: {
        customRender: 'effect_status'
      }
    }];
    this.queryList();
    this.queryCountryList();
    this.queryBodyList();
  };

  __decorate([userPrefPageSize('shopRecordList')], ShopDefaultThemeRecordPage.prototype, "initSearchData", null);

  __decorate([Watch('effectTimeRange', {
    immediate: true
  })], ShopDefaultThemeRecordPage.prototype, "onEffectTimeRangeChange", null);

  __decorate([loading('loadingStatus')], ShopDefaultThemeRecordPage.prototype, "queryList", null);

  ShopDefaultThemeRecordPage = __decorate([Component], ShopDefaultThemeRecordPage);
  return ShopDefaultThemeRecordPage;
}(Vue);

export default ShopDefaultThemeRecordPage;